function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export const scaleLogoOnMouseMove = ({
  initialMousePosition,
  currentMousePosition,
  initialMediaPixelParams,
  initialMediaPercentageParams,
  imprintAreaPixelParams,
  mediaRotationAngle
}) => {
  const mouseMovement = getMouseMovement(initialMousePosition, currentMousePosition, mediaRotationAngle);
  const logoAspectRatio = getLogoAspectRatio(imprintAreaPixelParams, initialMediaPercentageParams);
  const newPixelsLogoParams = calculateLogoParamsInPixels(initialMediaPixelParams, mouseMovement);
  const nonTurnedLogoParams = getNonTurnedLogoParams(newPixelsLogoParams, logoAspectRatio, mediaRotationAngle);
  const updatedLogoPercentageSize = calculateLogoSizeInPercentage(nonTurnedLogoParams, imprintAreaPixelParams);
  const updatedLogoPercentagePosition = getUpdatedLogoPercentagePosition(initialMediaPercentageParams, updatedLogoPercentageSize, mediaRotationAngle);
  return _objectSpread({}, initialMediaPercentageParams, updatedLogoPercentageSize, updatedLogoPercentagePosition);
};
export const scaleTextOnMouseMove = ({
  initialMousePosition,
  currentMousePosition,
  initialMediaPixelParams,
  initialMediaPercentageParams,
  imprintAreaPixelParams,
  fontSize,
  mediaRotationAngle
}) => {
  const mouseMovement = getMouseMovement(initialMousePosition, currentMousePosition, mediaRotationAngle);
  const newPixelsLogoParams = calculateLogoParamsInPixels(initialMediaPixelParams, mouseMovement);
  const delta = newPixelsLogoParams.width / initialMediaPixelParams.width;
  const updatedMediaPercentageSize = calculateLogoSizeInPercentage(newPixelsLogoParams, imprintAreaPixelParams);
  const initialMediaPercParams = _objectSpread({}, initialMediaPercentageParams, calculateLogoSizeInPercentage(initialMediaPixelParams, imprintAreaPixelParams));
  const updatedLogoPercentagePosition = getUpdatedLogoPercentagePosition(initialMediaPercParams, updatedMediaPercentageSize, mediaRotationAngle);
  return _objectSpread({}, updatedMediaPercentageSize, updatedLogoPercentagePosition, {
    fontSize: fontSize * delta,
    angle: mediaRotationAngle
  });
};
const RESIZE_ICON_ANGLE = 135;
export const getMouseMovement = (startPosition, currentPosition, mediaRotationAngle = 0) => {
  const delta = currentPosition.x - startPosition.x;
  const processedAngle = (mediaRotationAngle - RESIZE_ICON_ANGLE) % 360;
  const positiveProcessedAngle = processedAngle > 0 ? processedAngle : 360 + processedAngle;
  const isResizeIconToTheRight = positiveProcessedAngle > 90 && positiveProcessedAngle < 270;
  const direction = isResizeIconToTheRight ? 1 : -1;
  const deltaWithRotating = delta * direction;
  return {
    x: deltaWithRotating
  };
};
export const calculateLogoParamsInPixels = (initialLogoPixelParams, mouseMovement) => {
  const newWidth = initialLogoPixelParams.width + mouseMovement.x;
  const scale = newWidth / initialLogoPixelParams.width;
  const newHeight = initialLogoPixelParams.height * scale;
  return {
    width: newWidth,
    height: newHeight
  };
};
export const calculateLogoSizeInPercentage = (logoPixelsSize, imprintAreaPixelParams) => ({
  width: logoPixelsSize.width / imprintAreaPixelParams.width * 100,
  height: logoPixelsSize.height / imprintAreaPixelParams.height * 100
});
export const getNonTurnedLogoParams = (turnedLogoSize, logoAspectRatio, angle) => {
  const radianAngle = angle / 180 * Math.PI;
  const {
    width
  } = turnedLogoSize;
  const nonTurnedWidth = width / (Math.abs(Math.sin(radianAngle)) / logoAspectRatio + Math.abs(Math.cos(radianAngle)));
  const nonTurnedHeight = nonTurnedWidth / logoAspectRatio;
  return {
    width: nonTurnedWidth,
    height: nonTurnedHeight
  };
};
export const getUpdatedLogoPercentagePosition = (initialLogoPixelParams, updatedLogoPixelParams, logoRotationAngle) => {
  const processedAngle = logoRotationAngle % 360;
  const positiveProcessedAngle = processedAngle > 0 ? processedAngle : 360 + processedAngle;
  const isResizeIconOnTop = positiveProcessedAngle >= 135 && positiveProcessedAngle <= 315;
  const isResizeIconOnLeft = positiveProcessedAngle >= 45 && positiveProcessedAngle <= 225;
  let updatedLeft = initialLogoPixelParams.left;
  let updatedTop = initialLogoPixelParams.top;
  if (isResizeIconOnTop) {
    const heightDelta = initialLogoPixelParams.height - updatedLogoPixelParams.height;
    updatedTop = initialLogoPixelParams.top + heightDelta;
  }
  if (isResizeIconOnLeft) {
    const widthDelta = initialLogoPixelParams.width - updatedLogoPixelParams.width;
    updatedLeft = initialLogoPixelParams.left + widthDelta;
  }
  return {
    top: updatedTop,
    left: updatedLeft
  };
};
const getLogoAspectRatio = (imprintAreaPixelParams, logoRect) => {
  const logoWidth = imprintAreaPixelParams.width * logoRect.width / 100;
  const logoHeight = imprintAreaPixelParams.height * logoRect.height / 100;
  return logoWidth / logoHeight;
};
export const getMouseDirectionToCenter = (logoCenterPosition, mousePosition) => {
  const deltaY = mousePosition.y - logoCenterPosition.y;
  const deltaX = mousePosition.x - logoCenterPosition.x;
  const distanceToCenter = Math.sqrt(deltaY * deltaY + deltaX * deltaX);
  const needToInvertXAxis = deltaY > 0;
  let rotateAngle = Math.asin(deltaX / distanceToCenter) / Math.PI * 180;
  if (needToInvertXAxis) {
    rotateAngle = 180 - rotateAngle;
  }
  const processedAngle = rotateAngle % 360;
  const positiveProcessedAngle = processedAngle >= 0 ? processedAngle : 360 + processedAngle;
  return Math.round(positiveProcessedAngle);
};
export const getRotationAngle = (mousePosition, logoCenterPosition, logoPixelParams) => {
  const halfOfLogoWidth = logoPixelParams.width / 2;
  const halfOfLogoHeight = logoPixelParams.height / 2;
  // you need to make a displacement through the reference point is on OX axis
  const displacement = Math.atan(halfOfLogoWidth / halfOfLogoHeight) + Math.PI;
  const mouseDirection = getMouseDirectionToCenter(logoCenterPosition, mousePosition);
  const angle = -displacement * 180 / Math.PI + mouseDirection;
  const processedAngle = Math.round(angle % 360);
  const positiveProcessedAngle = processedAngle >= 0 ? processedAngle : 360 + processedAngle;
  return positiveProcessedAngle;
};
export const isRectangleSame = (rect1, rect2) => {
  if (!rect1 || !rect2) {
    return false;
  }
  return rect1.top === rect2.top && rect1.left === rect2.left && rect1.width === rect2.width && rect1.height === rect2.height && rect1.angle === rect2.angle;
};